export default "__VITE_ASSET__7JSrEn5y__"